<div class="row">
  <div class="col-4">
    <mat-form-field
      class="fill"
      [class.mat-form-field-invalid]="formControl.errors && formControl.touched"
    >
      <mat-label innerText="{{ 'ticket.create.label__search_we' | translate }}"></mat-label>
      <input
        id="ctrlSingleSearchWE"
        matInput
        type="text"
        [formlyAttributes]="field"
        [formControl]="currentSearchCtrlWE"
        [matAutocomplete]="searchWE"
      />
      @if (isVisibleInputWaitingWE) {
        <button matSuffix mat-icon-button>
          <mat-spinner [diameter]="20"></mat-spinner>
        </button>
      }
    </mat-form-field>
  </div>
  <div class="col-8">
    <mat-form-field
      class="fill"
      [class.mat-form-field-invalid]="formControl.errors && formControl.touched"
    >
      <mat-label innerText="{{ 'ticket.create.label__search_other' | translate }}"></mat-label>
      <input
        id="ctrlSingleSearch"
        matInput
        type="text"
        [formlyAttributes]="field"
        [formControl]="currentSearchCtrl"
        [matAutocomplete]="search"
      />
      @if (isVisibleInputWaiting) {
        <button matSuffix mat-icon-button>
          <mat-spinner [diameter]="20"></mat-spinner>
        </button>
      }
    </mat-form-field>
  </div>
</div>
<div class="row w-100">
  <div class="col-12">
    <mat-autocomplete
      panelWidth="800px"
      (optionSelected)="changeSearch($event)"
      #search="matAutocomplete"
    >
      @if (searchList.length > 0) {
        <mat-option disabled="true">
          <div class="row w-100">
            <div class="col-2">
              {{ translateService.instant('ticket.autocomplete.VPSZ') }}
            </div>
            <div class="col-2">
              {{ translateService.instant('ticket.autocomplete.WE-No') }}
            </div>
            @if (searchBuildings) {
              <div class="col-2">
                {{ this.translateService.instant('ticket.autocomplete.WE-Additional-No') }}
              </div>
            }
            <div class="col-3">
              {{ this.translateService.instant('ticket.autocomplete.city') }}
            </div>
            <div class="col-3">
              {{ this.translateService.instant('ticket.autocomplete.street') }}
            </div>
          </div>
        </mat-option>
      }
      @for (option of searchList; track $index) {
        <mat-option (click)="selectSearchResult(option)" [value]="option">
          <div class="row w-100">
            <div class="col-2">
              {{ option?.vpsz ?? '' }}
            </div>
            <div class="col-2">
              {{ option?.siteName ?? '' }}
            </div>
            @if (searchBuildings) {
              <div class="col-2">
                {{ option?.siteAdditionalNumber ?? '' }}
              </div>
            }
            <div class="col-3 text-overflow">
              {{ option?.address?.city ?? '' }}
            </div>
            <div class="col-3 text-overflow">
              {{
                option?.address?.streetName ??
                  '' + (option?.address?.houseNumber ? ' ' + option?.address?.houseNumber : '')
              }}
            </div>
          </div>
        </mat-option>
      }
    </mat-autocomplete>
  </div>
</div>
<div class="row w-100">
  <div class="col-12">
    <mat-autocomplete
      panelWidth="800px"
      (optionSelected)="changeSearchWE($event)"
      #searchWE="matAutocomplete"
    >
      @if (searchListWE.length > 0) {
        <mat-option disabled="true">
          <div class="row w-100">
            <div class="col-2">
              {{ translateService.instant('ticket.autocomplete.VPSZ') }}
            </div>
            <div class="col-2">
              {{ translateService.instant('ticket.autocomplete.WE-No') }}
            </div>
            @if (searchBuildings) {
              <div class="col-2">
                {{ this.translateService.instant('ticket.autocomplete.WE-Additional-No') }}
              </div>
            }
            <div class="col-3">
              {{ this.translateService.instant('ticket.autocomplete.city') }}
            </div>
            <div class="col-3">
              {{ this.translateService.instant('ticket.autocomplete.street') }}
            </div>
          </div>
        </mat-option>
      }
      @for (option of searchListWE; track $index) {
        <mat-option (click)="selectSearchResultWE(option)" [value]="option">
          <div class="row w-100">
            <div class="col-2">
              {{ option?.vpsz ?? '' }}
            </div>
            <div class="col-2">
              {{ option?.siteName ?? '' }}
            </div>
            @if (searchBuildings) {
              <div class="col-2">
                {{ option?.siteAdditionalNumber ?? '' }}
              </div>
            }
            <div class="col-3 text-overflow">
              {{ option?.address?.city ?? '' }}
            </div>
            <div class="col-3 text-overflow">
              {{
                option?.address?.streetName ??
                  '' + (option?.address?.houseNumber ? ' ' + option?.address?.houseNumber : '')
              }}
            </div>
          </div>
        </mat-option>
      }
    </mat-autocomplete>
  </div>
</div>

<div class="preview">
  <div class="row">
    <div class="col-3">{{ 'ticket.autocomplete.WE-No' | translate }}</div>
    <div class="col-7">{{ selectedResult?.siteName ?? '' }}</div>
  </div>
  <div class="row">
    @if (searchBuildings) {
      <div class="col-3">
        {{ 'ticket.autocomplete.WE-Additional-No' | translate }}
      </div>
    }
    <div class="col-7">{{ selectedResult?.siteAdditionalNumber ?? '' }}</div>
  </div>
  <div class="row">
    <div class="col-3">{{ 'ticket.autocomplete.VPSZ' | translate }}</div>
    <div class="col-7">{{ selectedResult?.vpsz ?? '' }}</div>
  </div>
  <div class="row">
    <div class="col-3">{{ 'ticket.autocomplete.zip' | translate }}</div>
    <div class="col-7">{{ selectedResult?.address?.postalCode ?? '' }}</div>
  </div>
  <div class="row">
    <div class="col-3">{{ 'ticket.autocomplete.city' | translate }}</div>
    <div class="col-7">{{ selectedResult?.address?.city ?? '' }}</div>
  </div>
  <div class="row">
    <div class="col-3">{{ 'ticket.autocomplete.street' | translate }}</div>
    <div class="col-7">
      @if (selectedResult?.address) {
        <span>
          {{
            selectedResult.address?.streetName ??
              '' + ' ' + selectedResult.address?.houseNumber ??
              ''
          }}
        </span>
      }
    </div>
    @if (selectedResult) {
      <div class="col-2 delete" (click)="deleteSelected()">
        <mat-icon [matTooltip]="'ticket.autocomplete.delete' | translate">delete</mat-icon>
      </div>
    }
  </div>
</div>
